module.exports = __webpack_public_path__ + "ubuntu-lightitalic-webfont.f7b7564b3a5bc711fb92.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/ubuntu/ubuntu-lightitalic-webfont.woff2
// module id = ./src/assets/webfonts/ubuntu/ubuntu-lightitalic-webfont.woff2
// module chunks = styles